<script lang="ts">
	import cn from 'classnames';
	import { PUBLIC_GENERAL_SERVICE_URL } from '$env/static/public';
	import { generateSignature } from '$lib/utils/Signature';

	let isSend = false;
	let contactFormData = {
		part: '',
		email: '',
		scooter_type: '',
		year: '',
		vin: ''
	};

	const sendContactForm = async () => {
		let signature = await generateSignature();

		if (!validateForm()) {
			return;
		}

		const response = await fetch(PUBLIC_GENERAL_SERVICE_URL + 'contact', {
			method: 'POST',
			headers: signature,
			body: JSON.stringify(contactFormData)
		});
		const data = await response.json();

		isSend = true;
	};

	const validateEmail = (email: string) => {
		const re = /\S+@\S+\.\S+/;
		return re.test(email);
	};

	const validateForm = () => {
		if (!validateEmail(contactFormData.email)) {
			alert('Zadejte platný e-mail');
			return false;
		}

		if (contactFormData.part.length < 3) {
			alert('Zadejte název dílu');
			return false;
		}

		if (contactFormData.scooter_type.length < 3) {
			alert('Zadejte typ skútru');
			return false;
		}

		if (contactFormData.year.length < 3) {
			alert('Zadejte rok výroby');
			return false;
		}

		return true;
	};
</script>

<section
	class={cn(
		'bg-product-list-banner bg-black bg-contain bg-top bg-no-repeat py-6 text-center sm:mx-0',
		$$props.class
	)}
>
	<h3 class="text-primary mb-2 pt-16 text-lg font-bold sm:text-xl md:pt-44">
		Furt nic? Díl najdeme za Vás!
	</h3>

	{#if isSend}
		<h3 class="mb-4 text-white">Děkujeme! Zprávu jsme odeslali, v nejbižší době vám dáme vědět.</h3>
	{:else}
		<h3 class="mb-4 text-white">Nemůžete najít potřebný díl? Dejte nám vědět.</h3>
		<div class="styled-form mx-auto w-11/12 sm:w-3/4">
			<div class="flex w-full flex-wrap sm:flex-nowrap">
				<div class="m-1 my-3 w-full sm:w-1/2">
					<input type="text" placeholder="Jaký díl hledáte?" bind:value={contactFormData.part} />
				</div>
				<div class="m-1 my-3 w-full sm:w-1/2">
					<input type="text" placeholder="Váš e-mail" bind:value={contactFormData.email} />
				</div>
			</div>
			<div class="flex w-full flex-wrap sm:flex-nowrap">
				<div class="m-1 my-3 w-full sm:w-1/2">
					<div class="flex flex-nowrap">
						<div class="mr-1 w-1/2">
							<input
								type="text"
								placeholder="Typ skútru"
								bind:value={contactFormData.scooter_type}
							/>
						</div>
						<div class="ml-1 w-1/2">
							<input type="text" placeholder="Rok výroby" bind:value={contactFormData.year} />
						</div>
					</div>
				</div>
				<div class="m-1 my-3 w-full sm:w-1/2">
					<input
						type="text"
						class="!pb-3.5"
						placeholder="VIN (nepovinné)"
						bind:value={contactFormData.vin}
					/>
				</div>
			</div>
		</div>
		<button
			on:click={sendContactForm}
			class="mt-4 bg-red px-8 py-3 font-semibold uppercase text-white"
		>
			Odeslat
		</button>
	{/if}
</section>
